export default {"src":"/_next/static/media/press-readers-digest.8f1f0fbd.svg","height":57,"width":162,"blurWidth":0,"blurHeight":0};